module.exports = __webpack_public_path__ + "img/3.32404da2.jpg";